"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InputFieldInput;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InputField = require("./InputField.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function InputFieldInput(props) {
  return _react.default.createElement("input", _extends({}, props, {
    className: (0, _InputField.mInputField)("input").toString()
  }));
}